import { useLocation } from 'js/lib/useRouter';

const useIsEnterpriseSearch = () => {
  const { pathname } = useLocation();
  return /\/organizations\/[^/]+\/search/.test(pathname ?? '') || /\/programs\/.+\/browse/.test(pathname ?? '');
};

export default useIsEnterpriseSearch;
